import { render, staticRenderFns } from "./LoanApprovedAmountActivity.vue?vue&type=template&id=86a5f0ba&scoped=true&"
import script from "./LoanApprovedAmountActivity.vue?vue&type=script&lang=js&"
export * from "./LoanApprovedAmountActivity.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=86a5f0ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a5f0ba",
  null
  
)

export default component.exports